import { FC, memo } from "react";
import "./loading-indicator.scss";

const LoadingIndicator: FC = memo(() => (
  <div className="loader">Loading...</div>
));

export default LoadingIndicator;
